import { useSelector } from "react-redux"
import { useWebSocket } from "../../../../app/ws/WebSocketProvider"
import { selectCompanyGuid, selectCurrentUserDisplayname } from "../../../auth/authSlice"
import UserImage from "components/commons/UserImage"

export default function UserCard2({ user }) {

    const { connectionStatus: wsStatus, client: wsClient } = useWebSocket()
    const companyGuid = useSelector(selectCompanyGuid)
    const userDisplayName = useSelector(selectCurrentUserDisplayname)

    function handleTrill() {

        const topic = `company/${companyGuid}/user/${user.guid}`

        const message = {
            title: "Trill",
            body: `Hai ricevuto un trill da ${userDisplayName}`
        }

        try {
            console.log("Trilling on topic" + topic)
            wsClient.publish(topic, JSON.stringify(message))
        } catch (err) {
            console.error(`Error trying to publish ${message.toString()} on topic ${topic}`)
        }
    }

    return (
        <div className="card bg-dark h-100">
            <div className="card-header bg-black bg-opacity-10">
                <div className="row">
                <div className="col-auto"><UserImage guid={user.guid} />  </div>
                <div className="col">
                    <h5 className="m-0">{user.displayName}</h5>
                    <small className="text-accent">{capitalize(user.title)}</small>
                </div>
                </div>
              
            </div>
            <div className="card-body">

                <div className="row text-end">
                    <div>
                        <button onClick={handleTrill} className="btn btn-primary"><i className="fa-solid fa-bell"></i> Trill</button>
                    </div>
                </div>
            </div>
            <div className="card-footer">
                <small className="text-muted">
                    {
                        user.email ?
                            <><a href={`mailto:${user.email}`}><i className="fa-solid fa-envelope"></i></a> {user.email} </>
                            : <>no email </>

                    }
                </small>
            </div>
        </div >
    )
}

function capitalize(s) {
    return s[0] + s.slice(1).toLowerCase();
}